"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Created by aghavni.grigoryan  on 10/13/17.
 */
class ExportDataProcessingService {
    constructor() {
        this.EXPORT_LAYOUT_NAME = 'chart';
        this.EXCEL_EXPORT_LAYOUT_NAME = 'chartExcel';
    }
    /**
     * The base method that creates exportData interface like export data object.
     * @param {Map<string, string>} images - store all parts images that were bind to report view
     * @param {ExportType} exportType - selected export type
     * @param languageId
     * @param imageWidthHeight
     * @param widgetTitle
     * @returns {ExportDataDto}
     */
    buildExportData(images, exportType, languageId, imageWidthHeight, widgetTitle = '') {
        let imagesArray = Array.from(images.values());
        return {
            images: imagesArray,
            data: this.processExportData(imagesArray.length, imageWidthHeight, widgetTitle),
            languageId: languageId,
            exportType: exportType,
            layoutName: this.EXPORT_LAYOUT_NAME,
            fileName: `${this.getExportedFileName()}`
        };
    }
    buildExcelExportData(data, exportType, languageId) {
        return {
            images: [],
            data: data,
            languageId: languageId,
            exportType: exportType,
            layoutName: this.EXCEL_EXPORT_LAYOUT_NAME,
            fileName: `${this.getExportedFileName()}`
        };
    }
    /**
     * Method create file name according to needed extension.
     * @returns {string}
     */
    getExportedFileName() {
        let currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
        return `export_${currentDate}`;
    }
    /**
     * These method now just stored all processed data based on exportData interface.
     * Now it just store images, soon will be added filter data, data table, etc.
     * @param properties
     * @param imageWidthHeight
     * @param widgetTitle
     * @returns {StringUnionMap}
     */
    processExportData(properties, imageWidthHeight, widgetTitle) {
        return Object.assign({}, this.processExportImages(properties), { width: imageWidthHeight[0], height: imageWidthHeight[1], title: widgetTitle });
    }
    /**
     * Method creates map based on used images that will be used in export image creation.
     * @param imagesLength
     * @returns {any}
     */
    processExportImages(imagesLength) {
        let exportedReportDataMap = {};
        for (let index = 0; index < imagesLength; index++) {
            exportedReportDataMap[`image_${index}`] = `Image_${index}.png`;
        }
        return exportedReportDataMap;
    }
}
ExportDataProcessingService.EXPORT_SERVICE_URL_KEY = 'export-service';
ExportDataProcessingService.EXPORT_SERVICE_ENDPOINT = '/export';
ExportDataProcessingService.REPORT_EXPORT_SERVICE_URL_KEY = 'report-export-service';
ExportDataProcessingService.REPORT_EXPORT_SERVICE_ENDPOINT = '/export-report';
ExportDataProcessingService.EXPORT_SERVICE_METHOD = 'POST';
ExportDataProcessingService.EXPORT_SERVICE_CONTENT_TYPE = 'application/json';
ExportDataProcessingService.REPORT_EXPORT_SERVICE_CONTENT_TYPE = 'application/x-www-form-urlencoded';
exports.ExportDataProcessingService = ExportDataProcessingService;
//# sourceMappingURL=export-data-proccessing-service.js.map